import React from 'react';

import { Colors } from '../color/Colors';

export const StartIcon = () => {
  return (
    <div>
      <img src="/pictures/StartIcon.svg" alt="" style={{ filter: Colors.logoFilter }} />
    </div>
  );
};
